import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Typography,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";



const EmailTemplateDialog = ({ open, onClose, interviewUrl, jobTitle, templateData, refreshTemplates }) => {
  const emailTemplates = {
    Invitation: {
      subject:
        "{candidate_first_name} - {company_name} invites you to a video interview - Next steps",
      content: (jobTitle, interviewUrl) => `Hi {candidate_first_name}, 
        
      I hope this finds you well and thanks for your interest in our ${jobTitle} role. We look forward to learning more about you.
  
      The next step is a brief video interview with a few questions. It will only take a few minutes. Please complete the interview within the next 48 hours. 
  
      Start your interview here: ${interviewUrl}
  
      We recommend using the Chrome browser on any laptopor smartphone . if you are using an iPhone , please use
  
      Should you have any questions, feel free to reach out.`,
    },
    "Interview-Completed": {
      subject: "Your interview for {job_title} has been completed",
      content: (jobTitle) => `Hi {candidate_first_name}, 
      
      Thank you for completing your interview for the ${jobTitle} role. Our team will review your responses and get back to you soon.`,
    },
    Reminder: {
      subject: "Reminder: Complete your {job_title} interview",
      content: (jobTitle, interviewUrl) => `Hi {candidate_first_name}, 
      
      This is a gentle reminder to complete your video interview for the ${jobTitle} role. 
  
      Please complete the interview as soon as possible: ${interviewUrl}`,
    },
  };
  const [template, setTemplate] = useState("Invitation");
  const [subject, setSubject] = useState(emailTemplates.Invitation.subject);
  const [content, setContent] = useState(emailTemplates.Invitation.content(jobTitle, interviewUrl));

  const handleTemplateChange = (event) => {
    const selectedTemplate = event.target.value;
    setTemplate(selectedTemplate);
    setSubject(emailTemplates[selectedTemplate].subject);
    setContent(emailTemplates[selectedTemplate].content(jobTitle, interviewUrl));
  };

  const handleSubjectChange = (event) => {
    setSubject(event.target.value);
  };

  useEffect(() => {
    if (templateData) {
      setTemplate(templateData.type || "Invitation");
      setSubject(templateData.email_subject || "");
      setContent(templateData.email_content || "");
    }
  }, [templateData]);

  const handleSave = async () => {
    const requestBody = {
      email_template_id: templateData?.id,
      type: template,
      email_subject: subject,
      email_content: content,
    };

    try {
      const response = await fetch(
        templateData
          ? `https://api.a2ajobs.com/api/email-template-update`
          : "https://api.a2ajobs.com/api/email-template-create",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        }
      );

      if (response.ok) {
        alert(`Email Template ${templateData ? "Updated" : "Saved"} Successfully!`);
        onClose();
      } else {
        const errorData = await response.json();
        alert(`Error ${templateData ? "updating" : "saving"} template: ` + errorData.message);
      }
    } catch (error) {
      alert(`Failed to ${templateData ? "update" : "save"} email template: ` + error.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Email Template Manager</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <Typography>Select Email Template</Typography>
          <Select value={template} onChange={handleTemplateChange}>
            {Object.keys(emailTemplates).map((key) => (
              <MenuItem key={key} value={key}>
                {key}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Typography>Email Subject</Typography>
        <TextField fullWidth margin="normal" value={subject} onChange={handleSubjectChange} />

        <ReactQuill theme="snow" value={content} onChange={setContent} style={{ height: "200px" }} />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="error" sx={{ textTransform: "none" }}>
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary" sx={{ textTransform: "none" }}>
          {templateData ? "Update Template" : "Create Template"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailTemplateDialog;
